import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LanguageService } from './components/language/language.service';
import { LS } from './helpers/localStorage.enum';
import { DataService } from './services/data/data.service';
import { NavigationService } from './services/navigation/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'suntory';
  lang
  constructor(
    private translate: TranslateService,
    private navService: NavigationService,
    private dataService: DataService,
    private langService: LanguageService,
    private router: Router
  ) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (!event.url.includes('project')) {
          this.dataService.featureImages$.next([])
        }
        navService.appPrevRoute.push(event.url);
      });
  }

  ngOnInit() {
    this.navService.initService()
    this.initHost()
    this.initTranslations()
  }

  async initTranslations() {
    let langs
    try {
      langs = await this.langService.findAll('withJSON=true').toPromise()
    }
    catch (err) {
      console.warn('Language module is not initialized')
    }

    if (langs?.length) {
      langs.map(lang => {
        this.translate.setTranslation(lang.code, lang.json, true)
      })
    }
    else {
      

      this.translate.addLangs(['en', 'jp', 'de'])
    }
    this.translate.setDefaultLang('en')

    /** This retrieval of LS.defaultLang doesn't need subscription. Only runs on init */
    this.lang = localStorage.getItem(LS.defaultLang)
    if (!this.lang) return
    this.translate.use(this.lang)
  }

  initHost() {
    const ls = localStorage
      , devHost = ls.getItem('_host')

    if (devHost) {
      
      environment.baseApiUrl = devHost
    }
  }
}
